import React, { useMemo, useState } from "react";
import { Container, Row, Col, Button, Card, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Whatsapp, Envelope, Telephone, Clipboard, ClipboardCheck, Clock, GeoAlt } from "react-bootstrap-icons";
import contactImg from "../assets/img/contact-img.svg";
import "animate.css";
import "./css/Contactinfo.css";
import TrackVisibility from "react-on-screen";

export const Contact = () => {
  const whatsappNumber = "+8801782084390";
  const email = "ridoyfahim92@gmail.com";
  const phoneDisplay = "+880 1782-084390";

  // sanitize for wa.me (digits only)
  const waSanitized = useMemo(() => whatsappNumber.replace(/[^\d]/g, ""), [whatsappNumber]);

  const [copied, setCopied] = useState(null);
  const copy = async (text, key) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(key);
      setTimeout(() => setCopied(null), 1200);
    } catch {
      setCopied(null);
    }
  };

  // quick-intent mailto helpers
  const mailTo = (subject) =>
    `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
      "Hi Fahim,\n\nI’d like to discuss: " + subject + ".\n\n—"
    )}`;

  return (
    <section className="contact" id="connect" aria-label="Contact">
      <Container>
        <Row className="align-items-center g-4">
          <Col xs={12} md={6}>
            <TrackVisibility once>
              {({ isVisible }) => (
                <img
                  className={isVisible ? "animate__animated animate__zoomIn hero-illustration" : "hero-illustration"}
                  src={contactImg}
                  alt="Say hello illustration"
                />
              )}
            </TrackVisibility>
          </Col>

          <Col xs={12} md={6}>
            <TrackVisibility once>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2 className="mb-2">Get in Touch</h2>
                  <p className="text-muted mb-3">
                    I build Flutter apps, Laravel APIs, and React dashboards end-to-end. Prefer WhatsApp or email—
                    I usually reply within a day.
                  </p>

                  {/* Availability chips */}
                  <div className="d-flex flex-wrap gap-2 mb-4">
                    <Badge bg="dark"><Clock size={14} className="me-1" /> Usually replies in 24h</Badge>
                    <Badge bg="secondary"><GeoAlt size={14} className="me-1" /> Dhaka (GMT+6)</Badge>
                  </div>

                  {/* Primary CTAs */}
                  <div className="d-flex flex-wrap gap-2 mb-4">
                    <Button
                      as="a"
                      href={`https://wa.me/${waSanitized}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="success"
                    >
                      <Whatsapp className="me-2" /> WhatsApp Chat
                    </Button>
                    <Button as="a" href={`mailto:${email}`} variant="primary">
                      <Envelope className="me-2" /> Email Me
                    </Button>
                    <Button as="a" href={`tel:${waSanitized}`} variant="outline-light">
                      <Telephone className="me-2" /> Call
                    </Button>
                  </div>

                  {/* Contact cards with copy buttons */}
                  <div className="contact-grid">
                    <Card className="contact-card">
                      <Card.Body className="d-flex justify-content-between align-items-center">
                        <div>
                          <div className="label">WhatsApp</div>
                          <div className="value">{phoneDisplay}</div>
                        </div>
                        <OverlayTrigger placement="top" overlay={<Tooltip>Copy number</Tooltip>}>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => copy(phoneDisplay, "wa")}
                          >
                            {copied === "wa" ? <ClipboardCheck /> : <Clipboard />}
                          </Button>
                        </OverlayTrigger>
                      </Card.Body>
                    </Card>

                    <Card className="contact-card">
      <Card.Body className="d-flex justify-content-between align-items-center">
  <div className="contact-main">
    <div className="label">Email</div>
    <div className="value truncate" title={email}>{email}</div>
  </div>
  <OverlayTrigger placement="top" overlay={<Tooltip>Copy email</Tooltip>}>
    <Button className="no-shrink" variant="outline-secondary" size="sm" onClick={() => copy(email, "mail")}>
      {copied === "mail" ? <ClipboardCheck /> : <Clipboard />}
    </Button>
  </OverlayTrigger>
</Card.Body>
                    </Card>
                  </div>

                  {/* Quick intents */}
                  <h5 className="mt-4">Start fast</h5>
                  <div className="intent-grid">
                    <a className="intent" href={mailTo("Project Quote – Flutter app from design to launch")}>
                      📱 Project Quote
                    </a>
                    <a className="intent" href={mailTo("API & Database – schema + secure Laravel APIs")}>
                      🗃️ API & Database
                    </a>
                    <a className="intent" href={mailTo("React Admin Dashboard – integration & UX")}>
                      🖥️ React Dashboard
                    </a>
                    <a className="intent" href={mailTo("30-min Consultation – scope & roadmap")}>
                      🧭 30-min Consult
                    </a>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
